<template>
  <div class="recent-news">
    <div
      class="container-fluid page-header"
      :style="{ backgroundImage: 'url(' + require('@/assets/landing_page/buildings.jpg') +')' }"
    >
      <div class="row">
        <div class="col-12">
          <div class="page-title">Notícias</div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="container-fluid">
              <div class="row filter-row-news">
                <div class="col-12 d-flex">
                  <input
                    type="text"
                    placeholder="Pesquise notícias do seu interesse"
                    class="form-control"
                    v-model="filter.title"
                  />
                  <button class="btn btn-primary" v-on:click="filterTable()">Buscar</button>
                </div>
              </div>
              <!-- <hr /> -->
              <div class="row">
                <div class="col-12">
                  <div class="double-border d-flex w-100">
                    <div class="red-border"></div>
                    <div class="gray-border"></div>
                  </div>
                </div>
              </div>
              <div class="row row-news">
                <div class="col-lg-6 col-12" v-for="item in listNews" v-bind:key="item.id">
                  <div class="card news-card">
                    <router-link class="primary-a" :to="{ name: 'public.view-news', params:{id: item.id} }">
                      <div class="title-news">{{item.title}}</div>
                      <div class="call-news">{{limitText(item.short_title, 100)}}</div>
                    </router-link>
                    <div class="footer-news d-flex justify-content-between">
                      <div>
                        <i class="fa fa-calendar" aria-hidden="true"></i>
                        {{formatDate(item.news_date)}}
                      </div>
                      <div>
                        <i class="fa fa-eye" aria-hidden="true"></i>
                        {{item.number_clicks}}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <b-pagination
                    class="float-right"
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                    aria-controls="my-table"
                  ></b-pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import helper from "@/imports/Helpers";
import moment from "moment";

export default {
  name: "recent-news",
  data() {
    return {
      perPage: 6,
      currentPage: 1,
      rows: 0,
      listNews: [],
      filter: {
        title: ""
      }
    };
  },
  mounted() {
    this.providerData();
  },
  watch: {
    currentPage: {
      handler: function(value) {
        this.providerData();
      }
    }
  },
  methods: {
    filterTable() {
      this.currentPage = 1;
      this.providerData();
    },
    providerData: function() {
      axios
        .get(
          `${process.env.VUE_APP_API_HOST}/api/news_public?${this.urlBuild()}`
        )
        .then(response => {
          this.rows = response.data.total;
          this.listNews = response.data.data;
        });
    },
    urlBuild: function() {
      let url =
        "sort=-news_date&page[number]=" +
        this.currentPage +
        "&page[size]=" +
        this.perPage +
        (this.filter.title != "" ? `&filter[title]=${this.filter.title}` : "");
      return url;
    },
    formatDate: function(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    limitText: function(text, limit) {
      return helper.limitText(text, limit);
    }
  }
};
</script>

<style lang="scss">
@import "@/styles/General.scss";
.recent-news {
  .double-border {
    .red-border {
      border-top: 2px solid $red_primary;
      width: 10%;
    }
    .gray-border {
      border-top: 2px solid rgb(224, 221, 221);
      width: 90%;
    }
  }
  .news-card {
    position: relative;
    min-height: 23vh;
    padding-bottom: 50px;
    .primary-a {
      text-decoration: none;
      color: #212529;
    }
    .primary-a:hover {
      .call-news {
        color: #5f6064;
      }
    }
    .title-news {
      font-weight: bold;
      margin-bottom: 8px;
    }
    .footer-news {
      font-size: 14px;
      width: calc(100% - 3vw);
      color: #5f6064;
      position: absolute;
      bottom: 1vw;
      i {
        margin-right: 5px;
      }
    }
  }
  .row-news {
    margin-top: 2.5vh;
  }
  .filter-row-news {
    margin-bottom: 2.5vh;
    input {
      margin-right: 20px;
    }
  }
}
</style>